var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass:
        "m-nav__item m-topbar__notifications m-topbar__notifications--img m-dropdown m-dropdown--large m-dropdown--header-bg-fill m-dropdown--arrow m-dropdown--align-right m-dropdown--mobile-full-width",
      attrs: {
        "data-dropdown-toggle": "click",
        "data-dropdown-persistent": "true"
      }
    },
    [
      _c(
        "a",
        {
          staticClass: "m-nav__link m-dropdown__toggle",
          attrs: { href: "", id: "notify" },
          on: {
            click: function($event) {
              return _vm.changeNotificationsState(_vm.getNotifications)
            }
          }
        },
        [
          _vm.getNews > 0
            ? _c("span", {
                staticClass:
                  "m-nav__link-badge m-badge m-badge--dot m-badge--dot-small m-badge--danger",
                attrs: { id: "point" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(0)
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "m-dropdown__wrapper" }, [
        _c("span", {
          staticClass: "m-dropdown__arrow m-dropdown__arrow--right"
        }),
        _vm._v(" "),
        _c("div", { staticClass: "m-dropdown__inner" }, [
          _c(
            "div",
            {
              staticClass: "m-dropdown__header m--align-center",
              staticStyle: {
                background:
                  "url(assets/app/media/img/misc/notification_bg.jpg)",
                "background-size": "cover"
              }
            },
            [
              _c("span", { staticClass: "m-dropdown__header-title" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("capitalize")("notifications")) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "m-dropdown__header-subtitle" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm._f("capitalize")(
                        _vm.$i18n.tc("new_notification", _vm.getNews, {
                          num: _vm.getNews
                        })
                      )
                    ) +
                    "\n\t\t\t\t\t"
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "m-dropdown__body" }, [
            _c("div", { staticClass: "m-dropdown__content" }, [
              _c("div", { staticClass: "tab-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "tab-pane active",
                    attrs: {
                      id: "topbar_notifications_notifications",
                      role: "tabpanel"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "m-scrollable",
                        attrs: {
                          "data-scrollable": "true",
                          "data-max-height": "250",
                          "data-mobile-max-height": "200"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "m-list-timeline m-list-timeline--skin-light"
                          },
                          [
                            _vm.getNotifications.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "m-list-timeline__items" },
                                  _vm._l(_vm.getNotifications, function(
                                    notification,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "m-list-timeline__item"
                                      },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "m-list-timeline__badge -m-list-timeline__badge--state-success"
                                        }),
                                        _vm._v(" "),
                                        notification.open_message
                                          ? [
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    notification.route === ""
                                                      ? "m-list-timeline__text text-nowrap"
                                                      : "m-list-timeline__text cursor-pointer text-nowrap"
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.openModal(
                                                            index,
                                                            notification.route
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          notification.content
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "m-list-timeline__time"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm._f("capitalize")(
                                                          _vm._f("subDates")(
                                                            notification.created_date
                                                          )
                                                        )
                                                      ) +
                                                      "\n                          "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "m-list-timeline__icon text-right"
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "cursor-pointer btn_notify_delete",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.deleteNotification(
                                                            {
                                                              id:
                                                                notification.id,
                                                              index: index
                                                            }
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-trash"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          : [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "m-list-timeline__text"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "m-list-timeline__time w-100 text-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                              " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "capitalize"
                                                            )(
                                                              _vm._f(
                                                                "subDates"
                                                              )(
                                                                notification.created_date
                                                              )
                                                            )
                                                          ) +
                                                          "\n                            "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "m-list-timeline__icon"
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "cursor-pointer btn_notify_delete",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.deleteNotification(
                                                                {
                                                                  id:
                                                                    notification.id,
                                                                  index: index
                                                                }
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-trash"
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      class:
                                                        notification.route ===
                                                        ""
                                                          ? ""
                                                          : "cursor-pointer"
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.openModal(
                                                                index,
                                                                notification.route
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              notification.content
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass:
                                                      "m-separator mb-2"
                                                  })
                                                ]
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  }),
                                  0
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "m--align-center btn_notify_delete"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            "no_notifications_text"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-nav__link-icon" }, [
      _c("span", { staticClass: "m-nav__link-icon-wrapper" }, [
        _c("i", { staticClass: "flaticon-music-2 notification-i" })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-360b9eb6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-360b9eb6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/layout/navbar/Notifications.vue
// module id = 555
// module chunks = 0 54 132 157